// Identifiant Google Analytics (GA4)
export const GA_MEASUREMENT_ID = "G-ELRZ1Z6X3Z";

let loaded = false;

export function loadGoogleAnalytics() {
  if (loaded) return;
  if (!GA_MEASUREMENT_ID) return;
  loaded = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID);
}
